/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import SourceDAO from 'file-browser/SourceDAO';
import notifications from 'notifications';
import getTestProps from 'test/lib/cypress/getTestProps';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {SingleEntityInput} from 'ui-library/entity-input/SingleEntityInput';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';
import APIUtil from 'util/APIUtil';
import strUtil from 'util/strUtil';

interface Props {
  addPartyAsCollaborator: (...args: Array<any>) => any;
  existingCollaboratorIds: Array<any>;
  ownableId?: string | null;
  labelText?: string;
}

type State = any;

class AddCollaboratorFormGroup extends React.Component<Props, State> {
  _isMounted: any;
  override state: State = {
    isInvitingCollaborator: false,
    text: '',
  };

  override componentDidMount(): void {
    this._isMounted = true;
  }

  override componentWillUnmount(): void {
    this._isMounted = false;
  }

  inviteCollaborator = (entityId: any): void => {
    this.setState({isInvitingCollaborator: true});

    SourceDAO.addCollaborator(this.props.ownableId!, {entity_id: entityId})
      .done(() => {
        notifications.success(`Successfully invited ${entityId}`);
      })
      .fail(notifications.notifyError)
      .always(() => {
        if (this._isMounted) {
          this.setState({isInvitingCollaborator: false});
        }
      });
  };

  _allowInvites = (): boolean =>
    this.props.ownableId != null &&
    APIUtil.apiIdToType(this.props.ownableId) === ModelTypeConstants.SOURCE &&
    BenchlingConfig.ENABLE_USER_SIGNUPS;

  canInviteQueryAsEmail = (): boolean => this._allowInvites() && strUtil.isValidEmail(this.state.text);

  _filterCollaborators = (tag: any, collaborators: any): any =>
    collaborators.filter(
      (collaborator: any) => !this.props.existingCollaboratorIds.includes(collaborator.id)
    );

  _handleSubmit = ({entity, email}: any): void => {
    if (entity) {
      this.props.addPartyAsCollaborator(entity);
      return;
    }
    assert(
      email && this.props.ownableId != null,
      'should have entity or both email and ownableId to add collaborator'
    );
    this.inviteCollaborator(email);
  };

  _handleChangeInput = (text: any): void => {
    this.setState({text});
  };

  override render(): JSX.Element {
    let buttonText = 'Add collaborator';
    if (this.state.isInvitingCollaborator) {
      buttonText = 'Inviting collaborator';
    } else if (this.canInviteQueryAsEmail()) {
      buttonText = 'Invite collaborator';
    }
    return (
      <FormGroup>
        <Label>{this.props.labelText || 'Manage collaborators'}</Label>
        <div className="input-group u-width-full">
          <div
            className="collaborator-search-container"
            {...getTestProps({component: 'AddCollaboratorFormGroup', element: 'root'})}
          >
            <SingleEntityInput
              allowEmails={this._allowInvites()}
              allowBenchlingApps={BenchlingConfig.ENABLE_BENCHLING_APPS}
              buttonProps={{
                buttonStyle: ButtonStyle.PRIMARY,
                disabled: this.state.isInvitingCollaborator,
                size: ButtonSize.MEDIUM,
                text: buttonText,
              }}
              filterOptions={this._filterCollaborators}
              onChangeInput={this._handleChangeInput}
              onSubmit={this._handleSubmit}
              size={TagsInputSize.MEDIUM}
            />
          </div>
        </div>
      </FormGroup>
    );
  }
}

export default AddCollaboratorFormGroup;
